export default "__VITE_PUBLIC_ASSET__c863516f__"